import React, { setGlobal } from "reactn";
import { MemoryRouter, Route, Switch } from "react-router-dom";

//components
import UserDetails from "./_steps/userDetails/userDetails";
import NewUserDetails from "./_steps/newUserDetails/newUserDetails";
import Subscriptions from "./_steps/subscriptions/Subscriptions";
import Review from "./_steps/review/review";
import ScrollToTop from "./_common/scrollToTop/ScrollToTop";

// styles
import AppWrapper from "./App.styled";
import { ThemeProvider } from "styled-components";
import ThemeProviderStyled from "./_theme/ThemeProvider.styled";

// Set global values used accroos the form
setGlobal({
    values: {
        paymentOption: "topUpOption",
        topUpValue: null
    }
});

const App = props => {
    return (
        <ThemeProvider theme={ThemeProviderStyled}>
            <AppWrapper>
                <MemoryRouter initialEntries={["/user-details", "/new-user-details", "/subscriptions", "/review"]} initialIndex={0}>
                    <ScrollToTop>
                        <Switch>
                            <Route exact path="/user-details" {...props} component={UserDetails} />
                            <Route exact path="/new-user-details" {...props} component={NewUserDetails} />
                            <Route exact path="/subscriptions" component={Subscriptions} />
                            <Route exact path="/review" component={Review} />
                        </Switch>
                    </ScrollToTop>
                </MemoryRouter>
            </AppWrapper>
        </ThemeProvider>
    );
};

export default App;
